import { ACT_AUTH_CHANGE } from "./ActionTypes";
import AuthService from "../provider/auth/AuthService";
import UserService from "../provider/user/UserService";
import Roles from "../config/RolesConstants"
import {loading} from "./AppActions"

export function actionVerifyLogin(callback, onMessageListener){
	return (dispatch, getStore)=>{
		AuthService.registerAuthStateListener(
			(user)=>{
				if(user){
					UserService.getUsersByEmailOrDU(getStore().app.app,null, user.email).then((response)=>{
						const profile=response.users[0]
						const app = user.app&&user.app.length==1&&user.app[0]||"Bee Quick"
						dispatch({
							type: ACT_AUTH_CHANGE,
							props: {
								login: true,
								username: user.displayName,
								email: user.email,
								photo: user.photoURL,
								app: app, //Agregar app al usuario
								profile:profile
							}
						})
						const canReceiveNotis = profile.proRoles&&profile.proRoles.findIndex((r)=>{return r.id==Roles.OPERADOR})>=0
						canReceiveNotis&&AuthService.requestMessagingPermission(app, profile.proRestoId, profile.id, onMessageListener)
						callback(false)
					})
				}else{
					dispatch({
						type: ACT_AUTH_CHANGE,
						props: {
							login: false,
							username: null,
							email: null,
							photo: null,
							userId:null,
							app: null,
							profile: null
						}
					})
					callback(true)
					
					// logOutCallback()
				}
			}
		)
	}
}

export function actionLogin(user, successCalback, errorCallback) {
	return (dispatch, getStore) => {
		loading(true)(dispatch, getStore)
		AuthService.login(user)
		.then(
				res => {					
					// dispatch({
					// 	type: ACT_APP_CHANGE,
					// 	props: {
					// 		login: true,
					// 		username: res.name,
					// 		email: res.displayName,
					// 		photo: res.photoURL,
					// 		app: res.app&&res.app.length==1&&res.app[0]||"Nuevamente" //Agregar app al usuario
					// 	}
					// });
					successCalback(res.app);//Modificar callback para que permita seleccionar la app si hay mas de una
				}
			)
		.catch(errorCallback)
		.finally(()=>loading(false)(dispatch, getStore))
	};
}

export function actionLogOut(){
	return (dispatch, getStore)=>{
		let deleteListenerData = false
		try{
			const profile = getStore().auth.profile
			const app = getStore().auth.app
			const canReceiveNotis = profile.proRoles&&profile.proRoles.findIndex((r)=>{return r.id==Roles.OPERADOR})>=0
			if(canReceiveNotis){
				deleteListenerData = {app:app, restoId:profile.proRestoId, userId:profile.id}
			}
		}catch(e){
			console.log("ERROR", e)
		}
		AuthService.logout(deleteListenerData)
	}
}


export function createAccount(user, successCalback, errorCallback) {
	return (dispatch, getStore) => {
		loading(dispatch,true)
		AuthService.createAccount(user)
		.then(res => {
			console.log("RESPONSE", res)
			dispatch({
				type: "CREATE_USER",
				props: res
			});
			successCalback();
		})
		.catch(errorCallback)
		.finally(
			()=>{
				loading(dispatch,false)
			}
		)
	}
}

export function forgotPassword(email, callback) {
	return (dispatch, getStore) => {
		AuthService.forgotPassword(email)
			.then(function(resp) {
				callback(true);
			})
			.catch(function(error) {
				callback(false);
			});
	};
}

export function confirmPasswordReset(code, password, callback) {
	return (dispatch, getStore) => {
		AuthService.confirmPasswordReset(code, password)
			.then(function(resp) {
				callback(true, resp);
			})
			.catch(function(error) {
				callback(false, error);
			});
	};
}

// export function requestMessagingPermission(code, password, callback) {
// 	return (dispatch, getStore) => {
// 		AuthService.requestMessagingPermission()
// 			.then(function(resp) {
// 				callback(true, resp);
// 			})
// 			.catch(function(error) {
// 				callback(false, error);
// 			});
// 	};
// }


/* Ejemple de uso del servicio CrudAction
export function actionListConfigSetting(params, callback) {
  params = params || {};
  return (dispatch, getStore) => {
    dispatch({
      type: CHANGE_CONFIG_SETTINGS_PROPS,
      props: { gridFetchingData: true }
    });
    // Llamada al servicio list
    action
      .list(params)
      .then(response => {
        if (response.isSessionExpired()) {
          dispatch(actionLogout);
          return;
        }
    }
*/



// WEBPACK FOOTER //
// ./src/actions/AuthActions.js